import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

import { MenuItemExpandableLinkProps } from './MenuItemExpandableLink.types';

export const LeftBarDecoration = styled.div`
  display: none;
  position: absolute;
  left: 0;
  width: 4px;
  height: 100%;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  overflow: hidden;

  &:before {
    display: block;
    position: absolute;
    content: '';
    left: 0;
    height: 100%;
    width: 2px;
    background: ${Colors.BrandBlueLightest};
  }
`;

export const Header = styled.div`
  display: flex;
  height: 40px;
  align-items: center;
`;

export const Content = styled.div`
  display: none;
  flex-flow: column;
  padding: 8px 0 10px 0;
  margin-left: 30px;
  border-top: 1px solid ${Colors.Dark};
`;

export const MenuItemExpandableLinkStyled = styled(NavLink)<MenuItemExpandableLinkProps>`
  position: relative;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 500;
  height: 40px;
  text-decoration: none;
  color: ${ct({ Dark: Colors.GreyDarkerMiddle, Light: Colors.GreyDarkerMiddle })};
  background: transparent;
  border-radius: 4px;
  transition: background-color 0.1s ease-in-out, color 0.1s ease-in-out;
  overflow: hidden;

  &:not(.active):hover {
    color: ${ct({ Dark: Colors.BrandBlueLight, Light: Colors.BrandBlueLight })};
    background: ${ct({ Dark: Colors.DarkestMiddle, Light: Colors.DarkestMiddle })};
  }

  &.active {
    background: ${ct({ Dark: Colors.DarkerText, Light: Colors.DarkerText })};
    height: initial;

    ${LeftBarDecoration} {
      display: block;
    }

    ${Content} {
      display: flex;
      margin-top: -2px;
    }
  }

  ${({ variant }) => {
    if (variant === 'collapsed') {
      return css`
        width: 42px;
      `;
    }
  }}
`;
